import { ReactElement } from "react";

import PageContainer from "~frontend/components/PageContainer";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";
import { useTenant } from "~frontend/providers/LoggedInUserProvider";

import OrgSubaccountsEnable from "./OrgSubaccountsEnable";
import OrgSubaccountsList from "./OrgSubaccountsList";

export function Subaccounts(): ReactElement {
  const tenant = useTenant()!;
  useBreadcrumbs([
    {
      label: "Subaccounts",
      path: "/organization/subaccounts",
    },
  ]);

  return (
    <PageContainer maxWidth="lg">
      {tenant.subaccountsEnabled ? (
        <OrgSubaccountsList />
      ) : (
        <OrgSubaccountsEnable />
      )}
    </PageContainer>
  );
}
